module.exports = __webpack_public_path__ + "img/06_DSC7786-min.021b0df5.jpg";